import { Outlet, createFileRoute } from '@tanstack/react-router';

const Home = () => <Outlet />;

export const Route = createFileRoute('/app/task')({
  component: Home,
});
